const Ayuda = () => {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">Ayuda</h1>
        <p className="mt-1 text-sm text-gray-500">
          Recursos y soporte para optimizar el uso de Worky en tu universidad
        </p>
      </div>
    </div>
  );
};

export default Ayuda; 